'use strict';

const Header = {
    el: null,
    toggle: null,
    init: function() {
        Header.el = document.querySelector('.header');
        if (Header.el) {
            Header.toggle = Header.el.querySelector('.header__toggle');

            if (Header.toggle) {
                Header.toggle.addEventListener('click', () => {
                    Header.el.classList.toggle('navOpened');
                });
            }

            //Add scroll spy
            window.addEventListener('scroll', () => {
                if (window.scrollY === 0) {
                    if (Header.el.classList.contains('scrolled--'))
                        Header.el.classList.remove('scrolled--');
                } else {
                    if (Header.el.classList.contains('scrolled--')) return;
                    else Header.el.classList.add('scrolled--');
                }
            });

            const submenus = Header.el.querySelectorAll(
                '.menu-item-has-children'
            );

            if (submenus) {
                submenus.forEach((submenu) => {
                    submenu.addEventListener('click', () =>
                        Header.toggleSubenu(submenu)
                    );
                    if (window.matchMedia('(min-width: 1025px)').matches) {
                        submenu.addEventListener('mouseenter', () => {
                            submenu
                                .querySelector('ul')
                                .classList.add('submenu--open');
                        });
                        submenu.addEventListener('mouseleave', () =>
                            submenu
                                .querySelector('ul')
                                .classList.remove('submenu--open')
                        );
                    }

                    submenu.querySelectorAll('ul li').forEach((x) => {
                        x.addEventListener('click', () => {
                            Header.el.classList.remove('navOpened');
                            if (
                                window.matchMedia('(max-width: 1024px)').matches
                            ) {
                                submenu
                                    .querySelector('ul')
                                    .classList.remove('submenu--open');
                            }
                        });
                    });
                });
            }
        }
    },
    /* Mobile only */
    toggleSubenu: function(submenu) {
        if (window.matchMedia('@max-width: 1024px')) {
            submenu.classList.toggle('open--');
        }
    },
};

export default Header;



// WEBPACK FOOTER //
// ./src/scripts/components/Header.js